import { atom } from "recoil";

export const genericCRUDModelState = atom<any>({
    key: 'genericCRUDModelState',
    default: []
})